import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export const CheckBox = ({ value, onChange }) => {
    return (_jsx(_Fragment, { children: _jsx("input", { type: "checkbox", checked: value, onChange: onChange }) }));
};
